var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 48,
    viewBox: "0 0 78 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 50,
    height: 20,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 38,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 19,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#A1C7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.417d03d0d5a6308d433b93397614612d.svg";
export { ForwardRef as ReactComponent };